module.exports = __webpack_public_path__ + "img/4.78a1788b.webp";